module.exports = __webpack_public_path__ + "static/NewJune-bold-3266ee20d4b051754d728c84c6a7554b.woff";